import { useEffect, useState } from "react";

type WalkieTalkieMessage = (
  event: MessageEvent,
  data: string | Record<string, any>
) => void;

function useWalkieTalkie() {
  const [messageListeners, setMessageListeners] = useState<
    WalkieTalkieMessage[]
  >([]);

  const listen = (cb: WalkieTalkieMessage) => {
    setMessageListeners((prev) => [...prev, cb]);
  };

  const runListeners: WalkieTalkieMessage = (event, data) => {
    messageListeners.forEach((cb) => {
      cb(event, data);
    });
  };

  const send = (data: Record<string, any>, widgetId?: string | number) => {
    console.log("send", data, window.top);
    if (!window.top) return;

    window.top.postMessage(
      JSON.stringify({ ...data, type: "walkietalkie", widgetId }),
      "*"
    );
  };

  const connect = () => {
    window.addEventListener("message", (event) => {
      if (event.data.type !== "walkietalkie") return;
      try {
        const data = JSON.parse(event.data);
        runListeners(event, data);
      } catch (e) {
        console.error("The event message is not a json string", e);
      }
    });
  };

  useEffect(() => {
    connect();
  }, []);

  return { send, listen };
}

export { useWalkieTalkie };
